export class SetCurrentView {
   public static readonly type = '[AppointmentDialog] set view';

   constructor(public view: number) {}
}

export class OpenAppointmentDialog {
   public static readonly type = '[AppointmentDialog] open dialog';

   constructor(public orgId: number, public brickId: string) {}
}

export class CloseAppointmentDialog {
   public static readonly type = '[AppointmentDialog] close dialog';

   constructor() {}
}
